<template>
  <div class="evalua_page-root stu_create_evalua-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">
          <span v-if="classInfo.is_special_train === 1">【快】</span>
          {{classInfo.name}}
        </p>
      </yioks-page-nav>
      <div class="content-wrap">
        <div class="info-show evaluat_user-root">
          <div class="avator">
            <img
              class="img"
              :src="isImgLoadErr ? $options._myOpt.momentCover:classInfo.moment_picture"
              @error="isImgLoadErr = true"
            >
          </div>
          <div class="info">
            <p  v-if="classInfo.class_level==='C' || classInfo.class_level ==='D' ">培训日期：{{classInfo.start_date | time(false)}} 至 {{classInfo.end_date | time(false)}}</p>
            <div style="display: flex;align-items: center" v-if="classInfo.class_level==='A' || classInfo.class_level ==='B' ">
              <p>培训第一阶段：{{dataPhase.start_date | time(false)}} 至 {{dataPhase.end_date | time(false)}}</p>
              <p style="margin-left: 30px ">培训第二阶段：{{dataPhase.start_date1 | time(false)}} 至 {{dataPhase.end_date1 | time(false)}}</p>
            </div>
            <p>训练场地：{{classInfo.training_address}}</p>
            <p>理论课场地：{{classInfo.theory_address}}</p>
            <p>
              <span>培训机构：{{classInfo.org_name}}</span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>主讲师：{{classInfo.teacher_off_name}}</span>
              <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
              <span v-if="classInfo.teacher_name">助理讲师：{{classInfo.teacher_name}}</span>
              <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
              <span v-if="classInfo.lecturer_assistant_name">讲师助理：{{classInfo.lecturer_assistant_name}}</span>
            </p>
          </div>
        </div>
        <!-- <p class="evalua-tip">该问卷调查将直接提交至中国足协且为匿名方式，调查结果只有中国足协培训负责人可以看到，任何讲师和培训组织方均看不到调查结果，请大家依据实际情况填写。<br>本问卷调查目的在于请所有学员对讲师、培训组织方做出真实、客观评价，形成监督、反馈机制，有助于中国足协进一步改善教练员培训工作。<br/>中国足协感谢您为中国足球的发展做出的努力。</p> -->
        <div class="evalua-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="$options._myOpt.vuescrollOpt">
              <div class="scroll-content">
                <p class="evalua-tip">该问卷调查将直接提交至中国足协且为匿名方式，调查结果只有中国足协培训负责人可以看到，任何讲师和培训组织方均看不到调查结果，请大家依据实际情况填写。<br>本问卷调查目的在于请所有学员对讲师、培训组织方做出真实、客观评价，形成监督、反馈机制，有助于中国足协进一步改善教练员培训工作。<br/>中国足协感谢您为中国足球的发展做出的努力。</p>
                <div class="evaluat-box">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对机构{{orgEvaluatRes.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.starNum"></yioks-rating>
                  <div v-show="orgEvaluatRes.starNum < 5">
                    <p class="cont-title">存在以下现象</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="orgEvaluatRes.contsList"></yioks-evaluation>
                  </div>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="orgEvaluatRes.suggest"
                      rows="2"
                      placeholder="如有其他意见，请输入内容，没有意见可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{orgEvaluatRes.suggest.length}}/100</span>
                  </div>
                </div>
                <div class="evaluat-box" v-for="item in teaEvaluatRes" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对{{item.type}}{{item.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>
                  <div v-show="item.starNum < 5">
                    <p class="cont-title">存在以下现象</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </div>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如有其他意见，请输入内容，没有意见可不填。"
                      class="textarea"
                      maxlength="100"
                    >
                    </textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="post-btn">
        <div class="btn save" @click="tipsFlag=true">匿名提交</div>
        <div class="btn cancel" @click="goBack">取消</div>
      </div>
      <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
      <yioks-tips :showTips="tipsFlag" :tips="$options._myOpt.tipMsg" @hideTips="hideTipsDialog"></yioks-tips>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { correctStatus } from "@/assets/js/apiStatus";
import { getStuRatingInfo, saveEvaluat } from "@/api/training_student/api";
import momentCover from "@/assets/images/class_logo.png";
import {
  transContsList,
  transData,
  paramsEvalData
} from "@/assets/js/evaluation";
const HOSTURL = process.env.VUE_APP_URL;
const SPLIT_CHAR = ",";

export default {
  name: "StuCreateEvaluation",
  _myOpt: {
    vuescrollOpt: createScrollOpt(),
    momentCover,
    tipMsg: "匿名提交后不可更改，是否确定提交？"
  },
  props: {},
  components: {
    "v-icon": Icon,
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-rating": () => import("@/components/Rating/Rating"),
    "yioks-evaluation": () => import("@/components/EvaluaConts/EvaluaConts"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  },
  created() {
    this.ratingInfo();
  },
  data() {
    return {
      tipsFlag: false,
      backComfim: false,
      classInfo: {},
      dataPhase:{},
      isImgLoadErr: false,
      orgEvaluatRes: {
        name: "",
        starNum: 0,
        suggest: "",
        contsList: []
      },
      teaEvaluatRes: []
    };
  },
  methods: {
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.push({
        path: "/student/class_detail"
      });
      } else {
      }
    },
    // 是否确定提交数据弹窗
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        // 提交数据
        this.saveEvaluat();
      } else {
      }
    },
    saveEvaluat() {
      const { orgEvaluatRes, teaEvaluatRes } = this;
      const teaEvalData = paramsEvalData(teaEvaluatRes);
      if (
        orgEvaluatRes.starNum === 0 ||
        teaEvalData.some(({ star }) => star === 0)
      ) {
        this.$message.error("星级评价为必评项");
        return;
      }
      const orgEvalData = {
        star: orgEvaluatRes.starNum,
        other_eva: orgEvaluatRes.suggest,
        tag_list: orgEvaluatRes.contsList.map(({ id, checked }) => ({
          eva_id: id,
          is_option: orgEvaluatRes.starNum >= 5 ? 0:(checked ? 1 : 0)
        }))
      };
      saveEvaluat({
        org_eval_data: JSON.stringify(orgEvalData),
        tea_eval_data: JSON.stringify(teaEvalData)
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          // this.goBack();
          this.$router.push({
        path: "/student/class_detail"
      });
        } else {
        }
      });
    },
    ratingInfo() {
      getStuRatingInfo().then(({ data }) => {
        if (data.status === correctStatus) {
          const { result } = data;
          const { class_info, eva_to_tea, eva_to_org,eva_data_goalkeeper,dataPhase, eva_data_physical } = result;
          if (dataPhase){
            this.dataPhase={
              start_date:dataPhase[0].start_date,
              start_date1:dataPhase[1].start_date,
              end_date:dataPhase[0].end_date,
              end_date1:dataPhase[1].end_date,
            }
          }
          this.classInfo = {
            ...class_info,
            moment_picture: class_info.moment_picture
              ? HOSTURL + class_info.moment_picture
              : ""
          };

          const offTeachIds = String(this.$yioks
            .nullToStr(class_info.teacher_off_ids))
            .split(SPLIT_CHAR);
          const offTeachNames = this.$yioks
            .nullToStr(class_info.teacher_off_name)
            .split(SPLIT_CHAR);
          this.teaEvaluatRes.push(...transData(offTeachIds, offTeachNames, eva_to_tea, "主讲师","official"));
          if(class_info.teacher_ids&&class_info.teacher_name){
            const teachersIds = this.$yioks
            .nullToStr(class_info.teacher_ids)
            .split(SPLIT_CHAR);
            const teachersNames = this.$yioks
            .nullToStr(class_info.teacher_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(teachersIds, teachersNames, eva_to_tea, "助理讲师","assistant"));
          }
          if(class_info.lecturer_assistant_ids&&class_info.lecturer_assistant_name){
            const lecturerAssistantIds = this.$yioks
            .nullToStr(class_info.lecturer_assistant_ids)
            .split(SPLIT_CHAR);
            const lecturerAssistantNames = this.$yioks
            .nullToStr(class_info.lecturer_assistant_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(lecturerAssistantIds, lecturerAssistantNames, eva_to_tea, "讲师助理","lecturer_assistant"));
          }
          if(eva_data_goalkeeper){
            const goalkeeperIds = ["0"];
            const goalkeeperNames = ["守门员专项讲师"];
            this.teaEvaluatRes.push(...transData(goalkeeperIds, goalkeeperNames, eva_data_goalkeeper, "","goalkeeper"));
          }
          if(eva_data_physical){
            const physicalIds = [""];
            const physicalNames = ["体能专项讲师"];
            this.teaEvaluatRes.push(...transData(physicalIds, physicalNames, eva_data_physical, "","physical"));
          }
          this.orgEvaluatRes = {
            name: class_info.org_name,
            starNum: 0,
            suggest: "",
            contsList: transContsList(eva_to_org)
          };
        } else {
        }
      });
    },
    goBack() {
      this.backComfim = true;
    }
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluation'
@import '~@/assets/css/evaluatUserShow'
.stu_create_evalua-root {
  .main-content-wrap .content-wrap .evalua-wrap {
    height: 470px;
  }
}
</style>
